<template>
    <div>
        <config-main-title v-if="!setup">
            Validação Geral de Tabelas de Preços
        </config-main-title>

        <div class="card dashcard">
            <div class="card-body">
                <div class="form-row">
                    <div class="col col-12 d-flex flex-column mb-2">
                        <az-input
                            type="button-group"
                            :optionsList="[
                                { id: 'procedimento', search: 'Procedimento' },
                                { id: 'material', search: 'Material' },
                                { id: 'medicamento', search: 'Medicamento' },
                            ]"
                            optionsData="id"
                            optionsDisplay="search"
                            v-model="tipo_item"
                            :edicao="tipo != 'P'"
                            @input="load_tabelas(); load();" />
                    </div>
                </div>
                <div class="form-row mb-2" v-if="tipo_item == 'procedimento'">
                    <div class="col col-12 col-md-3">
                        <az-input 
                            icon="fa fa-filter"
                            type="select" 
                            placeholder="Especialidades..."
                            optionsMode="esp-ativas"
                            optionsName="esp-ativas"
                            :edicao="tipo_item == 'procedimento'"
                            :optionsReload="true"
                            v-model="especialidade">
                        </az-input>
                    </div>
                    <div class="col col-12 col-md-9 d-flex flex-column">
                        <az-input
                            type="button-group"
                            :optionsList="[
                                { id: 'O', search: 'Operadoras' },
                                { id: 'P', search: 'Particular' },
                            ]"
                            optionsData="id"
                            optionsDisplay="search"
                            v-model="tipo"
                            :edicao="tipo_item == 'procedimento'"
                            @input="load()" />
                    </div>
                </div>
                <div class="form-row">
                    <template v-if="tipo == 'P'">
                        <div class="col col-12 col-md-6">
                            <az-input 
                                icon="far fa-check-square fa-fw"
                                type="select"
                                placeholder="Todas os Particulares..."
                                :optionsList="particulares"
                                optionsData="id_plano"
                                optionsDisplay="search"
                                v-model="filtro_plano">
                                <template v-slot:button-pre>
                                    <div class="input-group-prepend">
                                        <button class="btn btn-outline-primary" type="button" id="button-addon1" @click="page = 1; load()" :disabled="$store.state.loading">
                                            <i class="fas fa-sync-alt"></i>
                                        </button>
                                    </div>
                                </template>
                            </az-input>
                        </div>
                    </template>

                    <template v-else>
                        <div class="col col-12 col-md-3">
                            <az-input 
                                type="select"
                                placeholder="Selecione o Campo..."
                                :optionsList="[
                                    { id: 'st_codigo', search: 'Código' },
                                    { id: 'dc_filme', search: 'Filme' },
                                    { id: 'moeda.st_moeda', search: 'Moeda' },
                                    { id: 'dc_valor', search: 'Valor' },
                                ]"
                                optionsData="id"
                                optionsDisplay="search"
                                :edicao="tipo == 'O'"
                                v-model="campo_valid">
                                <template v-slot:button-pre>
                                    <div class="input-group-prepend">
                                        <button class="btn btn-outline-primary" type="button" id="button-addon1" @click="page = 1; load()" :disabled="$store.state.loading">
                                            <i class="fas fa-sync-alt"></i>
                                        </button>
                                    </div>
                                </template>
                            </az-input>
                        </div>
                        <div class="col col-12 col-md-3">
                            <az-input 
                                icon="far fa-check-square fa-fw"
                                type="select"
                                placeholder="Todas as Tabelas..."
                                :optionsList="tabelas"
                                optionsData="id_tabela_versao"
                                optionsDisplay="search"
                                v-model="filtro_tabela" />
                        </div>
                    </template>

                    <div class="col col-12 col-md-3">
                        <az-input
                            icon="fa fa-search fa-fw"
                            v-model="search" 
                            @input="page = 1">
                            <template v-slot:buttonposb>
                                <print-export printid="lista-precos" :dados="dados_exportacao" :left="true" />
                            </template>
                        </az-input>

                        <az-input
                            v-if="false"
                            type="button-group"
                            :edicao="filtro_tabela > 0"
                            :optionsList="[
                                { id: 'T', search: 'Todos' },
                                { id: 'S', search: 'CBHPM' },
                                { id: 'N', search: 'Não CBHPM' },
                            ]"
                            optionsData="id"
                            optionsDisplay="search"
                            v-model="filtro_cbhpm"
                            @input="load()" />
                    </div>

                    <div class="col col-12 col-md-3 d-flex flex-column">
                        <az-input
                            type="button-group"
                            :edicao="filtro_tabela > 0"
                            :optionsList="[
                                { id: 'T', search: 'Todos' },
                                { id: 'V', search: 'Vinc...' },
                                { id: 'N', search: 'Não Vinc...' },
                            ]"
                            optionsData="id"
                            optionsDisplay="search"
                            v-model="vinculo"
                            @input="load()" />
                    </div>
                    
                </div>

                <div class="form-row mt-2" v-if="false">
                    <div class="col col-12">
                        <az-input
                            icon="fa fa-search fa-fw"
                            v-model="search" 
                            @input="page = 1"/>
                    </div>
                </div>
            </div>
        </div>

        <div class="progress mt-1 mb-3">
            <div class="indeterminate" v-if="$store.state.loading && lista && lista.length"></div>
            <div class="determinate" v-else></div>
        </div>

        <div v-if="( !lista || !lista.length )">
            <az-empty-state icon="fas fa-filter" msg="Selecione a Especialidade" v-if="!especialidade" />
			<az-empty-state msg="Nenhum procedimento disponível para essa especialidade" v-else />
        </div>

        <div v-else-if="dados && tabelas" id="lista-precos">

            <span class="small text-muted" v-if="( dados && dados.last_page > 1 )">
                {{ dados.from }} - {{ dados.to }}  / {{ dados.total }}
            </span>
        
            <table class="table table-hover bg-white" :class="( lista_tabelas && lista_tabelas.length > 10 ) ? 'table-responsive' : 'cabecalho-fixo'">
                <thead>
                    <tr>
                        <th>Descrição</th>
                        <th>Id</th>
                        <th v-if="filtro_tabela && tipo_item == 'procedimento'">CBHPM</th>
                        <th v-for="(tabela, itx) in lista_tabelas" :key="itx">
                            <small>
                                {{ tabela.search }}
                            </small>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, iix) in lista" :key="iix">
                        <td>
                            <small>
                                <a href="#" @click.prevent="$util.abrirProcedimento(item)">
                                    {{ item.search }}
                                </a>
                            </small>
                        </td>
                        <td class="small">
                            <template v-if="tipo_item == 'material'">#{{ item.id_material }}</template>
                            <template v-else-if="tipo_item == 'medicamento'">#{{ item.id_medicamento }}</template>
                            <template v-else-if="tipo_item == 'taxa'">#{{ item.id_taxa }}</template>
                            <template v-else>{{ item.st_sigla ? item.st_sigla : '#' + item.id_procedimento }}</template>
                        </td>
                        <td class="small" v-if="filtro_tabela && tipo_item == 'procedimento'">
                            {{ item.st_codigo_cbhpm }}
                        </td>
                        <td v-for="(tabela, itx) in lista_tabelas" :key="itx">
                            <!-- Particular -->
                            <template v-if="tipo == 'P'">
                                <span v-if="!validacao_partic(item, tabela) || !validacao_partic(item, tabela).fl_ativo">
                                    <i class="fas fa-times-circle text-danger mr-1"></i>
                                    <small>
                                        <a href="#" @click.prevent="editar_particular(item, tabela, validacao_partic(item, tabela))">
                                            Ativar
                                        </a>
                                    </small>
                                </span>
                                <span v-else>
                                    <span v-if="!validacao_partic(item, tabela).dc_valor">
                                        <i class="fas fa-question-circle text-primary"></i>
                                    </span>
                                    <i class="fa fa-check-circle text-success" v-else></i>

                                    <small class="ml-1">
                                        <a href="#" @click.prevent="editar_particular(item, tabela, validacao_partic(item, tabela))">
                                            {{ $util.formatMoeda(validacao_partic(item, tabela).dc_valor) }}
                                        </a>
                                    </small>
                                </span>
                            </template>

                            <!-- Operadora -->
                            <template v-else>
                                <template v-if="!validacao(item, tabela)">
                                    <a href="#" @click.prevent="acessarTabela (tabela, null, item)" class="card-link text-primary mr-1">
                                        <i class="fa fa-plus-circle" data-toggle2="tooltip" data-placement="top" title="Incluir na Tabela"></i>
                                    </a>
                                    <a href="#" @click.prevent="vincular (item, tabela)" class="card-link text-primary  ml-0 mr-1">
                                        <i class="fas fa-play-circle" data-toggle2="tooltip" data-placement="top" title="Vincular a Tabela"></i>
                                    </a>
                                </template>
                                <template v-else>
                                    <a href="#" @click.prevent="acessarTabela (tabela, validacao(item, tabela), item)" class="card-link" :class="!campo_valid || exibir_campo(item, tabela) ? 'text-success' : 'text-muted'">
                                        <i class="fa fa-check-circle" data-toggle2="tooltip" data-placement="top" title="Acessar a Tabela"></i>
                                    </a>
                                </template>

                                <small v-if="campo_valid">
                                    {{ exibir_campo(item, tabela) }}

                                    <span v-if="campo_valid == 'st_codigo' && filtro_tabela && item.st_codigo_cbhpm">
                                        <span v-if="exibir_campo(item, tabela) == item.st_codigo_cbhpm" class="badge badge-secondary ml-1">
                                            CBHPM
                                        </span>
                                    </span>
                                </small>
                            </template>
                        </td>
                    </tr>
                </tbody>
            </table>

        </div>

        <br><br><br><br><br>

        <nav class="navbar fixed-bottom navbar-light bg-light pb-3" v-if="dados && dados.last_page > 1">
            <div class="d-flex">
                <paginate
                    class="mb-0"
                    :page-count="dados.last_page"
                    :container-class="'pagination'"
                    :page-class="'page-item'"
                    :page-link-class="'page-link'"
                    :prev-class="'page-link'"
                    :next-class="'page-link'"
                    :prev-text="'<<'"
                    :next-text="'>>'"
                    :click-handler="paginar">
                </paginate>
            </div>
        </nav>

        <cadastro-item-tabela ref="cadtab" />

        <!-- Modal -->
        <div class="modal fade" id="vincularProcModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content" v-if="procedimento && tabela">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ procedimento.search }}</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                    </div>
                    <div class="modal-body">
                        <p class="alert alert-info">{{ tabela.search }}</p>
                        <az-input 
                            label="Selecione o Item da Tabela"
                            type="autocomplete" 
                            :service="tipo_item == 'procedimento' ? 'item_tabelas.index' : 'proprias.index'"
                            :optionsParm="{ id_tabela_versao: tabela.id_tabela_versao }"
                            optionsMode="aql"
                            required
                            v-model="itemTabelaVinculo"/>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="salvar_vinculacao()">Vincular</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal -->
        <div class="modal fade" id="valorParticularModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Valor Particular</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="valor_partic">
                        <h5>{{ procedimento.search }}</h5>
                        <h6 class="mb-3">{{ plano.search }}</h6>

                        <az-input
                            type="checkbox-group"
                            label="Ativo"
                            v-model="valor_partic.fl_ativo" />

                        <az-input
                            class="mt-3"
                            type="money"
                            label="Valor"
                            v-model="valor_partic.dc_valor" />
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="salvar_particular()">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <div class="row" v-if="false">
            <div class="col col-12 col-md-6">
                <pre class="alert alert-warning">{{ particulares }}</pre>
            </div>
            <div class="col col-12 col-md-6">
                <pre class="alert alert-warning">{{ lista }}</pre>
            </div>
        </div>

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';
import ConfigMainTitle from '../shared/ConfigMainTitle.vue';
import CadastroItemTabela from '../shared/CadastroItemTabela.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import PrintExport from '../../shared/PrintExport.vue';

export default {
    data () { 
        return { 
            dados: null, 
            tabelas: null, 
            campo_valid: "", 
            page: 1, 
            search: "", 
            especialidade: "", 
            procedimento: "",
            tabela: "", 
            itemTabelaVinculo: "", 
            filtro_tabela: "", 
            filtro_plano: "", 
            tipo: "O",
            particulares: [], 
            plano: "", 
            valor_partic: "", 
            vinculo: "T", 
            filtro_cbhpm: "T", 
            tipo_item: "procedimento", 
            tipo_tabelas: [], 
        }
    },

    props: ['setup'],

    components: { 
        AzInput,
        AzEmptyState,
        ConfigMainTitle, 
        CadastroItemTabela, 
        AzSubmit,
        PrintExport, 
    },

    computed: { 
        dados_exportacao: function () { 
            return this.lista.map(item => { 
                let preco = { 
                    descricao: item.search, 
                    id: item.id_procedimento, 
                    sigla: item.st_sigla,
                    codigo_cbhpm: item.st_codigo_cbhpm, 
                };

                this.lista_tabelas.forEach(tabela => {
                    preco[tabela.search] = this.campo_valid ? this.exibir_campo(item, tabela) : this.validacao(item, tabela); 
                });
                
                return preco;
            });
        },

        lista: function () { 
            if ( !this.dados )
                return [];

            let reg = this.$util.getregex(this.search);
            let lista = ( this.dados.data ? this.dados.data : this.dados );

            return lista.filter(item => !this.especialidade || item.id_especialidade == this.especialidade.id_especialidade)
                .filter(item => !this.search || reg.test(JSON.stringify(item)));
        },

        lista_tabelas: function () { 
            if ( this.tipo == 'P' ) { 

                if ( !this.particulares ) 
                    return [];

                return this.particulares.filter(item => !this.filtro_plano || item.id_plano == this.filtro_plano);

            }

            if ( !this.filtro_tabela || !this.tabelas ) 
                return this.tabelas;

            return this.tabelas.filter(item => item.id_tabela_versao == this.filtro_tabela);

        }

    },
    
    methods: { 
        salvar_particular () { 

            this.$util.atualizar (this, { 
                service: 'unidade_procedimentos',
                func: 'store_valores_particular',
                dados: [
                    {
                        unidade_procedimento_planos: this.valor_partic,
                    }
                ],
                modal: 'valorParticularModal',
                reload: true, 
            });

        },

        editar_particular (item, plano, valor) { 
            this.valor_partic = null;

            this.$nextTick(() => { 
                this.valor_partic = _.cloneDeep(valor);
                this.procedimento = item;
                this.plano = plano;

                if ( !this.valor_partic ) { 
                    this.valor_partic = { 
                        id_unidade_procedimento_plano: null, 
                        id_unidade_procedimento: item.unidade_procedimento.id_unidade_procedimento, 
                        id_plano: plano.id_plano,
                        dc_valor: 0, 
                        fl_ativo: true, 
                    };
                }
    
                $('#valorParticularModal').modal('show');
            });
        },

        salvar_vinculacao () { 

            if ( this.tipo_item == 'procedimento' ) { 

                let pit = [ 
                    { 
                        id_unidade: 1, 
                        procedimento_item_tabela: {  
                            id_procedimento_item_tabela: null, 
                            item_tabela: this.itemTabelaVinculo, 
                            id_item_tabela: this.itemTabelaVinculo.id_item_tabela,
                            id_procedimento: this.procedimento.id_procedimento,
                            fl_ativo: true,
                        }
                    }
                ];
    
                this.$util.atualizar(this, { 
                    service: 'procedimento_item_tabelas',
                    func: 'store',
                    dados: pit,
                    modal: 'vincularProcModal',
                    reload: true, 
                });

            } else { 

                let pit = [ 
                    { 
                        tipo_item: this.tipo_item,
                        id_unidade: 1, 
                        item_propria: {  
                            id_material_propria: null, 
                            id_medicamento_propria: null,
                            propria: this.itemTabelaVinculo, 
                            id_propria: this.itemTabelaVinculo.id_propria,
                            id_material: this.procedimento.id_material,
                            id_medicamento: this.procedimento.id_medicamento,
                            fl_ativo: true,
                        }
                    }
                ];
    
                this.$util.atualizar(this, { 
                    service: 'item_proprias',
                    func: 'store',
                    dados: pit,
                    modal: 'vincularProcModal',
                    reload: true, 
                });

            }

        },

        vincular (proc, tabela) { 
            this.itemTabelaVinculo = "";
            this.procedimento = proc;
            this.tabela = tabela;

            $('#vincularProcModal').modal('show');
        },

        exibir_campo(item, tabela) { 

            let base = ( this.tipo_item == 'material' || this.tipo_item == 'medicamento' ) ? 'propria' : 'item_tabela';

            let valor = _.get(this.validacao(item, tabela), base + '.' + this.campo_valid);

            if ( this.campo_valid == 'dc_valor' && valor !== null && valor !== undefined ) { 
                valor = this.$util.formatMoeda(valor, 6, 2);
            }

            return valor; 
        },

        paginar (page) {
            this.page = page;
            this.load();
        },

        load() { 
            let filtro = this.especialidade 
                ? { where: { id_especialidade: this.especialidade.id_especialidade } }
                : {};

            let service = this.tipo_item + 's';

            if ( this.tipo_item == 'material' ) { 
                service = 'materiais';
            }

            this.$util.load(this, { 
                service: service,
                parms: { 
                    valid_preco: true, 
                    tipo_item: this.tipo_item, 
                    tipo: this.tipo, 
                    ativos: true, 
                    ...filtro,
                    size: ( this.filtro_tabela > 0 ? 1000 : 100 ),
                    page: this.page,  
                    vinculo: this.vinculo, 
                    cbhpm: this.filtro_cbhpm, 
                    id_tabela_versao: this.filtro_tabela, 
                }
            });

            // where: {  id_procedimento: 1000, },
        },

        validacao_partic (proc, plano) { 
            if ( !proc || !proc.unidade_procedimento || !proc.unidade_procedimento.unidade_procedimento_planos )
                return;

            return proc.unidade_procedimento.unidade_procedimento_planos
                .find(item => item.id_plano == plano.id_plano);
        },

        validacao(proc, tabela) { 
            
            if ( this.tipo_item == 'procedimento' ) {

                if ( !proc || !proc.procedimento_item_tabela )
                    return;

                return proc.procedimento_item_tabela.filter(item => item.fl_ativo)
                    .find(item => item.item_tabela.fl_ativo && item.item_tabela.id_tabela_versao == tabela.id_tabela_versao);

            } else { 

                if ( !proc || !proc.item_propria )
                    return;

                return proc.item_propria.filter(item => item.fl_ativo)
                    .find(item => item.propria && item.propria.fl_ativo && item.propria.id_tabela_versao == tabela.id_tabela_versao);

            }

        },

        acessarTabela (tabela, item, proc) { 
            if ( !item ) { 
                if ( this.tipo_item == 'procedimento' ) { 
                    this.$refs.cadtab.incluirItemParaProcedimento(tabela, proc, this.load);
                } else { 
                    this.$refs.cadtab.incluirItemParaModel(tabela, proc, this.tipo_item, this.load);
                }
            } else { 
                this.$refs.cadtab.abrirItemTabela(item.id_item_tabela ? item.id_item_tabela : item.id_propria, this.refreshItem, tabela);
            }
        },

        load_tabelas () { 

            if ( this.tipo_tabelas[this.tipo_item] ) { 
                this.tabelas = this.tipo_tabelas[this.tipo_item];
                return;
            }

            this.$util.load(this, { 
                service: 'tabela_versaos',
                parms: { 
                    cadastro_procedimento: this.tipo_item == 'procedimento',
                    cadastro_materiais: this.tipo_item == 'material',
                    cadastro_medicamentos: this.tipo_item == 'medicamento',
                    cadastro_taxas: this.tipo_item == 'taxa',
                    validacao: true,
                },
                loadTo: res => { 
                    this.tabelas = res;
                    this.tipo_tabelas[this.tipo_item] = res;
                }
            });

        }

    },

    mounted() { 

        if ( !this.setup ) { 
            this.breadcrumb = [
                { name: "Configurações", path: "/cadastros"},
                { name: "Validação Geral de Preços", path: "/cadastros" },
            ];

            this.$store.commit('setBreadcrumb', this.breadcrumb);
        }

        this.$util.valid_permissao(this, 100);

        this.$util.load(this, { 
            service: 'tabela_versaos',
            parms: { 
                cadastro_procedimento: true,
                validacao: true,
            },
            loadTo: res => { 
                this.tabelas = res;
                this.tipo_tabelas['procedimento'] = res;
            }
        });

        this.$util.load(this, { 
            service: 'planos',
            parms: { 
                where: { 
                    id_operadora: 1 
                }
            },
            loadTo: res => { 
                this.particulares = res;
            }
        });

    }
}
</script>
<style scoped>
.vertical-text {
    transform: rotate(90deg);
    transform-origin: left top 0;
}
</style>